<template>
<svg viewBox="0 0 16 16" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-line-align-top`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.83008 4.68579V14.8401C8.8298 15.2982 8.45822 15.6702 8 15.6702C7.54192 15.67 7.1702 15.2981 7.16992 14.8401V4.68579H8.83008ZM4.83008 12.2952C4.82992 12.7534 4.4583 13.1252 4 13.1252C3.54184 13.1251 3.17008 12.7533 3.16992 12.2952V4.68579H4.83008V12.2952ZM12.8301 10.387C12.8298 10.8451 12.4582 11.217 12 11.217C11.5419 11.2169 11.1702 10.845 11.1699 10.387V4.68579H12.8301V10.387ZM14 1.13501C14.4583 1.13501 14.8299 1.50685 14.8301 1.96509C14.8301 2.42348 14.4584 2.79517 14 2.79517H2C1.54174 2.795 1.16992 2.42338 1.16992 1.96509C1.1701 1.50695 1.54186 1.13517 2 1.13501H14Z"/></svg>
</template>
<script>

export default {
  name: 'IconLineAlignTop',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
